export * from './aboutUs';
export * from './contactUs';
export * from './dndData/simpleListData';
export * from './ecommerce/ecommerceData';
export * from './faqList/general';
export * from './faqList/support';
export * from './faqList/pricing';
export * from './faqList/installation';
export * from './faqList/licenseTypes';
export * from './invoice/invoiceData';
export * from './portFolio/installation';
export * from './portFolio';
export * from './portFolio/sales';
export * from './pricing';
export * from './blog'
